import { CurrencyPipe, DecimalPipe } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
} from '@angular/core';
import { ContentfulService } from '@core/services/contentful.service';
import { AssetImageConfiguration } from '@features/lazy-image/components/lazy-asset-lazy/lazy-asset-lazy.component';
import { CropFocus } from '@features/lazy-image/components/lazy-picture/lazy-picture.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import { Itinerary, Trip } from '@generated/graphql';
import { LinkComponent } from '../../../../shared/link/link.component';
import { StarRatingComponent } from '../../../../shared/star-rating/star-rating.component';
import { LazyAssetComponent } from '../../../lazy-image/components/lazy-asset/lazy-asset.component';

@Component({
    selector: 'app-trips-itinerary-card',
    templateUrl: './trips-itinerary-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        LinkComponent,
        LazyAssetComponent,
        FontAwesomeModule,
        StarRatingComponent,
        DecimalPipe,
        CurrencyPipe,
    ],
})
export class TripsItineraryCardComponent implements OnInit {
    @Input() itinerary: Itinerary;
    @Input() trip: Trip;
    faClock = faClock;
    url: string;
    featuredImageConfiguration: AssetImageConfiguration;
    constructor(private contentfulService: ContentfulService) {}

    ngOnInit(): void {
        this.featuredImageConfiguration = {
            image: this.itinerary?.featuredImage,
            ratioWidth: 2,
            ratioHeight: 1,
            width: 400,
            width2x: 400,
            focus:
                (this.itinerary?.featuredImageCropFocus as CropFocus) ||
                'center',
        };
        this.url = `/adventure-trips/${this.trip?.urlSlug}/${this.itinerary?.urlSlug}`;
    }

    preloadItinerary(itinerary: Itinerary) {
        this.contentfulService.itinerary(itinerary.urlSlug).subscribe();
    }
}
